import { ScaleIcon, BeakerIcon, AcademicCapIcon, ArchiveIcon } from '@heroicons/react/outline'
import { Layout } from "../components"
import cn from "classnames"

const supportLinks = [
  {
    name: 'Konsultan Hukum',
    href: '#',
    description: 'Masyarakat dalam memenuhi kebutuhan hidupnya tidak selalu berjalan sukses sering timbul persoalan perlu diselesaikan melalui hukum. Rumitnya penafsiran hukum, birokrasi, alat bukti dan konflik kepentingan menyebabkan untuk mendapatkan kepastian hukum dan rasa keadilan merupakan hal yang tidak mudah. Perusahaan kami menyediakan ahli-ahli hukum dan Forensik yang kompeten dan Profesional untuk membantu anda/perusahaan menyelesaikan masalah Hukum.',
    icon: ScaleIcon,
  },
  {
    name: 'Konsultan Forensik',
    href: '#',
    description: 'Penyelesaian perkara selalu berkaitan dengan alat bukti dan keyakinan, tidak semua masyarakat dan penegak hukum kompeten memahami karakteristik bukti yang dapat digunakan sebagai alat untuk membuktikan kebenaran substansiil dan formil cara paripurna. Para ahli forensik dapat menjadi pilihan utama dan solusi untuk masalah hukum, Alat bukti dan membangun keyakinan ilmiah yang tidak terbantahkan kehandalannya.',
    icon: BeakerIcon,
  },
  {
    name: 'Publik dan Inhouse Training',
    href: '#',
    description: 'Manusia perlu ilmu pengetahuan, penguasaan teknologi, keterampilan (skill) dan kompetensi tertentu untuk memenuhi berbagai kebutuhan hidupnya. Sumber daya manusia  (SDM) yang unggul dan professional sangat dibutuhkan pada era Modern. Perusahaan kami menyelenggarakan Public & Inhouse training pada bidang: Investigasi, Pemalsuan Product, Grafonomi, Modern Safety & Security system, Forensik, Krimnalistik, Hukum dan Mediasi adalah untuk membentuk SDM yang unggul. ',
    icon: AcademicCapIcon,
  },
  {
    name: 'Produk',
    href: '#',
    description: 'Perusahaan kami menyediakan produk Forniture untuk laboratorium, peralatan, mesin dan perkakas untuk industri  dan UMKM, tekstil untuk rumah tangga dan hotel seperti handuk, seprai, bedcover, duve dan nafkin. Kami juga memproduksi minuman kaleng aneka jus buah segar, sirup jahe merah dan makan siap antar. ',
    icon: ArchiveIcon,
  },
]

export default function Example() {
  return (
    <Layout>
      <div className="bg-white">
        <div className="relative pb-32 bg-gray-900">
          <div className="absolute inset-0">
            <img
                className="w-full h-full object-cover"
                src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100"
                alt=""
            />
            <div className="absolute inset-0 bg-gray-800 bg-gradient-to-br from-gray-900 mix-blend-multiply" aria-hidden="true" />
            </div>
            <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl">Company Profile</h1>
            <p className="mt-6 max-w-5xl text-xl text-gray-300">
              <span className="font-medium text-blue-400">Jaya Sederhana<sup className="text-blue-400 text-xs"> (CV)  </sup> </span>  didirikan tahun 2006, diperbahrui tahun 2019 dengan NIB Usa­ha: 9120502810762. 
            </p>
            <p className="mt-6 max-w-4xl text-xl text-justify text-gray-300">
              Perusahaan kami terus melakukan pengembangan dan aplikasi Ilmu Pengetahuan dan Teknologi untuk produk-produk
              <span className="text-lg text-blue-400"> Mesin Industri dan Laboratorium. </span> 
              Pada Bidang Jasa kami menyediakan  
              <span className="text-lg text-blue-400"> Pelayanan Konsultan Hukum, Forensik dan Krimnalistik dan  Pelatiahn Publik dan Inhouse bidang Investigasi, Mediasi, Safety dan Security, Grafonomi, Pemalsuan Produk dan Teknologi Informasi dan Telekomunikasi.</span>
            </p>     
          </div>
        </div>

        {/* Overlapping cards */}
        <section className="-mt-32 max-w-7xl mx-auto relative z-10 pb-32 px-4 sm:px-6 lg:px-8" aria-labelledby="contact-heading">
          <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-2 lg:gap-y-0 lg:gap-x-8">
          {supportLinks.map((link, i) => (
            <div key={i} className={cn("flex flex-col bg-white rounded-2xl shadow-xl", {
              "mt-14" : ( i !== 0 && i !==1 )
            })}>
              <div className="flex-1 relative pt-16 px-6 pb-8 md:px-8">
                <div className="absolute top-0 p-5 inline-block bg-blue-600 rounded-xl shadow-lg transform -translate-y-1/2">
                  <link.icon className="h-6 w-6 text-white" aria-hidden="true" />
                </div>
                <h3 className="text-xl font-medium text-gray-900">{link.name}</h3>
                <p className="mt-4 text-sm leading-7 text-gray-500 text-justify">{link.description}</p>
                {
                  link.name === "Produk" &&
                  <div>
                    <p className="mt-4 text-sm leading-7 text-gray-800 font-medium text-justify">Produk : 
                      <span className="ml-2 text-gray-500 font-normal">
                      Coating Metal & Concret,
                      Incinerator, Mesin dan EPC,
                      Bahan kimia, Instrumen dan Furniture Laboratorium,
                      Agronomy dan konsultan Teknik,
                      Agen dan Perwakilan Energi Terbarukan,
                      Towel, Bedsheet & Hospital,
                      Mimunam Buah segar dan Sirup
                      </span>
                    </p>
                  </div>
                }
              </div>
            </div>
          ))}
          </div>
        </section>
      </div>
    </Layout>
  )
}
